import React, { useEffect, useState } from "react";
import funVar from "global/utils/funVar";
import Api from "modAws/ApiAws";
import { LienzoLectura } from "modAws/manten/Lienzo";

// Pagina PUBLICA (sin sesion) de un diagrama compartido: /Aws/Compartido/<token>. No usa el shell de la app ni el login:
// pide el diagrama al endpoint /free/compartido, que valida el token (vigente y no revocado).
const Visor = ({ token }) => {
    const [estado, setEstado] = useState({ cargando: true });
    useEffect(() => {
        let vivo = true;
        fetch(`${funVar.getUrlApi()}${Api.compartido}`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ param: { token } }) })
            .then(r => r.json())
            .then(d => { if (vivo) setEstado(d && d.ok && d.rows && d.rows[0] ? { datos: d.rows[0] } : { error: (d && d.msg) || "Enlace inválido o vencido." }); })
            .catch(() => { if (vivo) setEstado({ error: "No se pudo cargar el diagrama." }); });
        return () => { vivo = false; };
    }, [token]);
    const { datos, error, cargando } = estado;
    return (
        <div className="d-flex flex-column" style={{ position: "fixed", inset: 0, background: "var(--cui-body-bg, #fff)", color: "var(--cui-body-color, #212529)" }}>
            <div className="px-3 py-2 border-bottom d-flex align-items-center justify-content-between">
                <b><i className="fa fa-project-diagram me-2" />{datos ? `${datos.proyecto} / ${datos.nombre}` : "Diagrama compartido"}</b>
                {datos && <span className="badge text-bg-secondary">Solo lectura · vence {new Date(datos.expira).toLocaleDateString()}</span>}
            </div>
            {cargando && <div className="p-4 text-muted">Cargando…</div>}
            {error && <div className="p-4"><div className="alert alert-warning mb-0">{error}</div></div>}
            {datos && <LienzoLectura grafo={datos.grafo} />}
        </div>
    );
};
export default Visor;
